import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { InfoBar } from '@/components/feedback/InfoBar';
import { useShow360UnavailableInfoBar } from '@/hooks/useShow360UnavailableInfoBar/useShow360UnavailableInfoBar';

const ThreeSixtyDataUnavailableInfoBarWithData = () => {
  const { t } = useTranslation('dataVis');
  const show360UnavailableInfoBar = useShow360UnavailableInfoBar();

  return (
    show360UnavailableInfoBar && (
      <InfoBar testId="360-unavailable-info-bar" mainText={t('threeSixtyUnavailableInfoBar')} />
    )
  );
};

export const ThreeSixtyDataUnavailableInfoBar = () => (
  <Suspense fallback={<div className="hidden" data-testid="360-unavailable-info-bar-loading" />}>
    <ThreeSixtyDataUnavailableInfoBarWithData />
  </Suspense>
);
